var _style, _defs, _mask, _g, _defs2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoBeneficiariesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_2941_7945_00000077312332434127499220000010864410487828739980_);}\r\n\t.st2{fill:#15B79E;}\r\n\t.st3{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter_00000000936734369118831680000010242683052409911184_);}\r\n\t.st4{mask:url(#mask1_2941_7945_00000141425261547637562100000007250194713018082218_);}\r\n\t.st5{fill:#F59E0B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 2,
    y: 5.7,
    width: 13.3,
    height: 12.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5.7,
    width: 13.3,
    height: 12.6,
    id: "mask0_2941_7945_00000077312332434127499220000010864410487828739980_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.7,
    y: 0.6,
    className: "st0",
    width: 22.8,
    height: 22.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.6,11.4c-0.8,0-1.5-0.3-2-0.8c-0.6-0.6-0.8-1.2-0.8-2c0-0.8,0.3-1.5,0.8-2c0.6-0.6,1.2-0.8,2-0.8 s1.5,0.3,2,0.8c0.6,0.6,0.8,1.2,0.8,2c0,0.8-0.3,1.5-0.8,2C10.1,11.1,9.4,11.4,8.6,11.4z M2,18.3v-1.6c0-0.4,0.1-0.8,0.3-1.1 c0.2-0.3,0.5-0.6,0.9-0.8c0.9-0.4,1.8-0.8,2.7-1c0.9-0.2,1.8-0.3,2.7-0.3c0.9,0,1.8,0.1,2.7,0.3c0.9,0.2,1.8,0.5,2.7,1 c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.3,1.1v1.6H2z M2.9,17.3h11.4v-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.3-0.3-0.6-0.5 c-0.8-0.4-1.6-0.7-2.4-0.9s-1.7-0.3-2.5-0.3c-0.8,0-1.7,0.1-2.5,0.3c-0.8,0.2-1.6,0.5-2.4,0.9c-0.2,0.1-0.4,0.3-0.6,0.5 c-0.1,0.2-0.2,0.4-0.2,0.6V17.3z M8.6,10.5c0.5,0,1-0.2,1.3-0.6c0.4-0.4,0.6-0.8,0.6-1.3c0-0.5-0.2-1-0.6-1.3 C9.6,6.9,9.2,6.7,8.6,6.7s-1,0.2-1.3,0.6C6.9,7.6,6.7,8,6.7,8.6c0,0.5,0.2,1,0.6,1.3C7.7,10.3,8.1,10.5,8.6,10.5z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000102513415057850148270000010468562242329071516_",
    filterUnits: "userSpaceOnUse",
    x: 15.1,
    y: 11.4,
    width: 6.9,
    height: 6.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 15.1,
    y: 11.4,
    width: 6.9,
    height: 6.9,
    id: "mask1_2941_7945_00000141425261547637562100000007250194713018082218_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 10.1,
    style: {
      fill: "#D9D9D9",
      filter: "url(#Adobe_OpacityMaskFilter_00000102513415057850148270000010468562242329071516_)"
    },
    width: 9.6,
    height: 9.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.6,16.9c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2C18.4,16.9,18.5,16.9,18.6,16.9z M18.4,15.6h0.4 c0-0.2,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.1,0.1-0.3,0.1-0.5c0-0.3-0.1-0.6-0.3-0.8 s-0.5-0.3-0.8-0.3c-0.2,0-0.5,0.1-0.7,0.2c-0.2,0.1-0.4,0.3-0.5,0.5l0.4,0.2c0.1-0.2,0.2-0.4,0.3-0.4c0.1-0.1,0.3-0.1,0.4-0.1 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.4c-0.2,0.2-0.3,0.3-0.3,0.5 C18.4,15.2,18.4,15.4,18.4,15.6z M18.6,18.3c-0.5,0-0.9-0.1-1.3-0.3c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.6-0.7-0.7-1.1 c-0.2-0.4-0.3-0.9-0.3-1.3c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.7-0.6,1.1-0.7c0.4-0.2,0.9-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.4,1.1,0.7c0.3,0.3,0.6,0.7,0.7,1.1c0.2,0.4,0.3,0.9,0.3,1.3c0,0.5-0.1,0.9-0.3,1.3 c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.1,0.7C19.5,18.2,19,18.3,18.6,18.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBeneficiariesIcon);
export default __webpack_public_path__ + "static/media/no-beneficiaries-icon.6cb529ed17922e694a2a19193c994691.svg";
export { ForwardRef as ReactComponent };